import { Routes } from '@angular/router';
import { AuthComponent } from './Authentification/auth.component';
import { ForgotPasswordComponent } from './Authentification/login-form/forgot-password/forgot-password.component';
import { LoginFormComponent } from './Authentification/login-form/login-form.component';
import { AuthguardGuard } from './Authentification/authguard.guard';
import { PagesComponent } from './Pages/pages.component';
import { NotfoundComponent } from './Shared/Component/notfound/notfound.component';
import { MaindashboardComponent } from './Pages/maindashboard/maindashboard.component';
import { AngularComponent } from './POC/angular/angular.component';
import { PrimengComponent } from './POC/primeng/primeng.component';
import { MonitoringComponent } from './Shared/Component/toolbar/monitoring/monitoring.component';
import { AuditTrailComponent } from './Shared/Component/audit-trail/audit-trail.componenet';
import { CatDashboardComponent } from './Pages/cat-dashboard/cat-dashboard.component';
import { AuditTrailDetailsComponent } from './Pages/cat-dashboard/audit-trail-details/audit-trail-details.component';
import { CaisComponent } from './Pages/cais/cais.component';
import { CAISFDIDComponent } from './Pages/cais/cais-fdid/cais-fdid.component';
import { MyDataViewerComponent } from './Pages/my-data-viewer/my-data-viewer.component';
import { OrdersComponent } from './Pages/my-data-viewer/orders/orders.component';
import { TradesComponent } from './Pages/my-data-viewer/trades/trades.component';
import { RoutesComponent } from './Pages/my-data-viewer/routes/routes.component';
import { ActTradesComponent } from './Pages/my-data-viewer/act-trades/act-trades.component';
import { AllocationComponent } from './Pages/my-data-viewer/allocations/allocation.component';
import { CatsRoeViewerComponent } from './Pages/cat-dashboard/cat-roe-viewer/cats-roe-viewer.component';
import { NewROEEntryComponent } from './Shared/Component/new-roe-entry/new-roe-entry.component';
import { ClientDataExceptionComponent } from './Pages/my-data-viewer/client-data-exception/client-data-exception.component';
import { EquitiesSymbolComponent } from './Pages/ref-data-viewer/equities-symbol/equities-symbol.component';
import { RefDataViewerComponent } from './Pages/ref-data-viewer/ref-data-viewer.component';
import { OptionsSymbolComponent } from './Pages/ref-data-viewer/options-symbol/options-symbol.component';
import { MpidListComponent } from './Pages/ref-data-viewer/mpid-list/mpid-list.component';
import { CATErrorCodesComponent } from './Pages/ref-data-viewer/cat-error-codes/cat-error-codes.component';
import { CAISErrorCodesComponent } from './Pages/ref-data-viewer/cais-error-codes/cais-error-codes.component';
import { DuallyListedStockComponent } from './Pages/ref-data-viewer/dually-listed-stock/dually-listed-stock.component';
import { SurvillanceComponent } from './Pages/survillance/survillance.component';
import { FrontRunningComponent } from './Pages/survillance/front-running/front-running.component';
import { RegShoComponent } from './Pages/survillance/reg-sho/reg-sho.component';
import { MarketAbuseComponent } from './Pages/survillance/market-abuse/market-abuse.component';
import { OptionOriginCodeComponent } from './Pages/survillance/option-origin-code/option-origin-code.component';
import { MarketAccessComponent } from './Pages/survillance/market-access/market-access.component';
import { CatComponent } from './Pages/cat-dashboard/cat/cat.component';
import { FileUploadComponent } from './Shared/Component/toolbar/file-upload/file-upload.component';
import { NaturalPersonComponent } from './Pages/cais/natural-person/natural-person.component';
import { LegalEntityComponent } from './Pages/cais/legal-entity/legal-entity.component';
import { CAISLTIDComponent } from './Pages/cais/cais-ltid/cais-ltid.component';
import { CAISAuditTrailDetailsComponent } from './Pages/cais/shared-component/cais-audit-trail-details/cais-audit-trail-details.component';
import { CAISTIDComponent } from './Pages/cais/cais-tid/cais-tid.component';
import { FirmDesignatedIdComponent } from './Pages/ref-data-viewer/fdid-info/fdid-info.component';
import { ExceptionsComponent } from './Pages/cais/exceptions/exceptions.component';
import { BrokerMappingComponent } from './Pages/ref-data-viewer/broker-mapping/broker-mapping.component';
import { CAISReconComponent } from './Pages/cais/cais-recon/cais-recon.component';
import { CatsExceptionComponent } from './Pages/cat-dashboard/cat-exception/cats-exception.component';
import { AdministrationComponent } from './Pages/administration/administration.component';
import { UserLogComponent } from './Pages/administration/user-log/user-log.component';
import { CognitoComponent } from './Pages/administration/cognito/cognito.component';
import { AddUserComponent } from './Pages/administration/cognito/add-user/add-user.component';
import { UserListComponent } from './Pages/administration/cognito/user-list/user-list.component';
import { CatBillingComponent } from './Pages/cat-dashboard/cat-billing/cat-billing.component';
import { UserActionLogComponent } from './Pages/administration/user-action-log/user-action-log.component';
import { CatAnalytics } from './Pages/cat-dashboard/cat/cat-analytics/cat-analytics.component';
import { FinraExceptionMainComponent } from './Pages/cat-dashboard/finra-exception/finra-exception-main.component';
import { RegInquiryComponent } from './Pages/reg-inquiry/reg-inquiry.component';
import { FinraInquiryComponent } from './Pages/reg-inquiry/finra-inquiry/finra-inquiry.component';
import { CatReconComponent } from './Pages/cat-dashboard/cat-recon/cat-recon.component';
import { ComparativeReviewComponent } from './Pages/cat-dashboard/comparative-review/comparative-review.component';
import { CompExceptionDetailsComponent } from './Pages/cat-dashboard/comparative-review/comp-exception-details/comp-exception-details.component';
import { CompMatchedReportDetailsComponent } from './Pages/cat-dashboard/comparative-review/comp-matched-report-details/comp-matched-report-details.component';
import { OdrComponent } from './Pages/odr/odr.component';
import { VenueDetailsComponent } from './Pages/odr/venue-details/venue-details.component';
import { VenueRatesComponent } from './Pages/odr/venue-rates/venue-rates.component';
import { OdrReportsComponent } from './Pages/odr/odr-reports/odr-reports.component';
import { ODRSystemLogsComponent } from './Pages/odr/odr-system-logs/odr-system-logs.component';
import { ProcessedTransactionsExceptionComponent } from './Pages/odr/processed-transactions-exceptions/processed-transactions-exceptions';
import { InTransactionsComponent } from './Pages/odr/in-transactions/in-transactions.component';
import { ChangePasswordComponent } from './Authentification/login-form/change-password/change-password.component';
import { OdrTransactionComponent } from './Pages/odr/processed-transactions/odr-transaction/odr-transaction.component';
import { UserComponent } from './Pages/administration/maintenance/user.component';
import { NewPassword } from './Authentification/login-form/new-password/new-password';
import { VerifyOtp } from './Authentification/login-form/verify-otp/verify-otp';
import { SignIn } from './Authentification/login-form/sign-in/sign-in';
import { AdminAuthguardGuard } from './Authentification/adminauthguard.guard';
import { PwdChangeComponent } from './Pages/administration/cognito/pwd-change/pwd-change.component';
import { RegMmSymbolList } from './Pages/ref-data-viewer/reg-mm-symbol-list/reg-mm-symbol-list';

export const routes: Routes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            { path: '', component: LoginFormComponent, },
            { path: 'login', component: LoginFormComponent,
                children: [
                {
                    path: '', component: SignIn,
                },
                {
                    path: 'sign-in', component: SignIn,
                },
                {
                    path: 'new-password/:temporaryPasssword', component: NewPassword,
                    canActivate: [AuthguardGuard]
                },
                {
                    path: 'verify-otp', component: VerifyOtp,
                },
                {
                    path: 'change-password', component: ChangePasswordComponent,
                    canActivate: [AuthguardGuard]
                },
            {
                    path: 'forgot-password', component: ForgotPasswordComponent,
            }]
            }
            
        ]
    },    
    {
                path: 'pages',
                component: PagesComponent,
                canActivate: [AuthguardGuard],
                children: [

                    {
                        path: 'MainDashboard',
                        component: MaindashboardComponent,
                        // loadChildren: 'app/Pages/maindashboard/maindashboard.module#MaindashboardCompModule',
                        canActivate: [AuthguardGuard],
                    },
                    
                    // {
                    //     path: 'MainDashboard/Id',
                    //     // loadChildren: 'app/Pages/maindashboard/maindashboard.module#MaindashboardCompModule',
                    //     canActivate: [AuthguardGuard],
                    // },
                    // {
                    //     path: 'CAT',
                    //     // loadChildren: 'app/Pages/cat-dashboard/cat-dashboard.module#CATDashboardCompModule',
                    //     canActivate: [AuthguardGuard],
                    // },
                    {
                        path: 'CAIS',
                        component: CaisComponent,
                        children: [
                            { path: 'FDID', component: CAISFDIDComponent },
                            { path: 'Natural-Person', component: NaturalPersonComponent },
                            { path: 'Legal-Entity', component: LegalEntityComponent },
                            { path: 'LTID', component: CAISLTIDComponent },
                            { path: 'TID', component: CAISTIDComponent },
                            { path: 'Exception', component: ExceptionsComponent },
                            { path: 'Exception/:Date/:Code', component: ExceptionsComponent },
                            { path: 'Audit-Trail', component: CAISAuditTrailDetailsComponent },
                            { path: 'CAIS-Recon', component: CAISReconComponent },
                          ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'Surveillance',
                        component: SurvillanceComponent,
                        children:[
                            { path: 'Front-Running', component: FrontRunningComponent },
                            { path: 'Front-Running/:Date', component: FrontRunningComponent},
                            { path: 'Front-Running/:Date/:Code', component: CatsExceptionComponent },
                            { path: 'Market-Abuse', component: MarketAbuseComponent },
                            { path: 'Market-Abuse/:Date', component: MarketAbuseComponent },
                            { path: 'Market-Abuse/:Date/:Code', component: CatsExceptionComponent },
                            { path: 'Options-Origin-Code', component: OptionOriginCodeComponent },
                            { path: 'Reg-SHO', component: RegShoComponent},
                            { path: 'Reg-SHO/:Date', component: RegShoComponent},
                            { path: 'Reg-SHO/:Date/:Code', component: RegShoComponent},
                            { path: 'Market-Access', component: MarketAccessComponent },

                        ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'Reg-Inquiry',
                        component: RegInquiryComponent,
                        children:[
                             { path: 'Inquiry', component: FinraInquiryComponent }
                        ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'My-Data-Viewer',
                        component : MyDataViewerComponent,
                        children:[
                            { path: 'Orders', component: OrdersComponent },
                            { path: 'Trades', component: TradesComponent },
                            { path: 'Routes', component: RoutesComponent },
                            { path: 'ACT-Trades', component: ActTradesComponent },
                            { path: 'Allocations', component: AllocationComponent },
                            { path: 'Client-Data-Exception', component: ClientDataExceptionComponent},
                            { path: 'Client-Data-Exception/:Date', component: ClientDataExceptionComponent},
                            { path: 'Client-Data-Exception/:Date/:Code', component: ClientDataExceptionComponent},                               ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'Ref-Data-Viewer',
                        component: RefDataViewerComponent,
                        children:[
                            { path: 'FDID', component: FirmDesignatedIdComponent },
                            { path: 'Broker-Map', component: BrokerMappingComponent },
                            { path: 'Reg-MM-List', component: RegMmSymbolList,canActivate: [AuthguardGuard]},
                            { path: 'Equities', component: EquitiesSymbolComponent },
                            { path: 'Options', component: OptionsSymbolComponent },
                            { path: 'IMID-List', component: MpidListComponent },
                            { path: 'CAT-Error-Codes', component: CATErrorCodesComponent},
                            { path: 'CAIS-Error-Codes', component: CAISErrorCodesComponent},
                            { path: 'Dually-Listed', component: DuallyListedStockComponent},
                        ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'Configure',
                        component: AdministrationComponent,
                        children:[
                            { path: 'Maintenance', component: UserComponent },
                            { path: 'User-Log', component: UserLogComponent },
                            { path: 'User-Action-Log', component: UserActionLogComponent},
                            { path: 'User-Maintenance',component: CognitoComponent, canActivate: [AdminAuthguardGuard],
                                  children: [
                                    { path:'',redirectTo:'Add-User',pathMatch:'full'},
                                    {path: 'Add-User',component: AddUserComponent,canActivate: [AdminAuthguardGuard]},
                                    {path: 'User-List',component: UserListComponent,canActivate: [AdminAuthguardGuard]},
                                    {path: 'User-Log', component: UserLogComponent,canActivate: [AdminAuthguardGuard]},
                                    {path: 'User-Action-Log', component: UserActionLogComponent,canActivate: [AdminAuthguardGuard]},
                                    {path: 'Change-Password', component: PwdChangeComponent,canActivate: [AdminAuthguardGuard]},

                                  ]
                            }
                            
                        ],
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'File Upload',
                        component: FileUploadComponent,
                        canActivate: [AuthguardGuard],
                    },
                    // {
                    //     path: 'Order-Viewer',
                    //     // component: OrderViewerComponent,
                    //     canActivate: [AuthguardGuard],
                    // },
                    // {
                    //     path: 'Order-Viewer/:JSON',
                    //     // component: OrderViewerComponent,
                    //     canActivate: [AuthguardGuard],
                    // },
                     {
                        path: 'System-Monitoring',
                        component: MonitoringComponent,
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'New-ROE-Entry',
                        component: NewROEEntryComponent,
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'Audit-Trail',
                        component: AuditTrailComponent,
                        canActivate: [AuthguardGuard],
                    },
                    {
                        path: 'CAT',
                        component: CatDashboardComponent,
                        children: [
                            { path: 'CAT', component: CatComponent},
                            { path: 'CAT-ROE-Viewer', component: CatsRoeViewerComponent },
                            { path: 'CAT-Exception', component: CatsExceptionComponent },
                            { path: 'Comparative-Review', component: ComparativeReviewComponent,
                                children:[
                                            { path: 'Sample', component: CompMatchedReportDetailsComponent },
                                            { path: 'Exception', component: CompExceptionDetailsComponent }
                                        ],
                             },
                            { path: 'CAT-Exception/:Date', component: CatsExceptionComponent },
                            { path: 'CAT-Exception/:Date/:Code', component: CatsExceptionComponent },
                            { path: 'Finra-Exception',component: FinraExceptionMainComponent },
                            { path: 'Finra-Exception/:Date',component: FinraExceptionMainComponent },
                            { path: 'Finra-Exception/:Date/:Code',component: FinraExceptionMainComponent },
                            { path: 'Finra-Exception/:Date/:Code/:Days',component: FinraExceptionMainComponent },
                            // { path: 'LTID', component: LTIDComponent },
                            { path: 'Audit-Trail', component: AuditTrailDetailsComponent },
                            { path: 'CAT-Analytics', component:  CatAnalytics },
                            { path: 'CAT-Recon', component: CatReconComponent },
                            { path: 'CAT-Billing', component: CatBillingComponent }
                        ],
                        // Apply AuthGuard to Parent (Menu) Only
                        canActivate: [AuthguardGuard]
                    },
                    {
                        path: 'Reg-Reporting',
                        component: OdrComponent,
                        children: [
                            { path: 'Venue-Details', component: VenueDetailsComponent },
                            { path: 'Venue-Rates', component: VenueRatesComponent },
                            { path: '606-Reports', component: OdrReportsComponent },
                            { path: 'System-Logs', component: ODRSystemLogsComponent },
                            { path: 'Order-Details', component: OdrTransactionComponent },
                            { path: 'Order-Details/:fromDate/:toDate/:transactionType', component: OdrTransactionComponent },
                            { path: 'Order-Details/:fromDate/:toDate/:transactionType/:value', component: OdrTransactionComponent },
                            { path: 'Exceptions', component: ProcessedTransactionsExceptionComponent },
                            { path: 'In-Transactions', component: InTransactionsComponent }
                        ],
                        canActivate: [AuthguardGuard]
                    },      
                    {
                        path: '**',
                        component: NotfoundComponent
                    }
                ]
            },           
            {
                path: 'POC',
                component: PagesComponent,
                children: [
                    { path: 'Angular', component: AngularComponent },
                    { path: 'PrimeNG', component: PrimengComponent },
                ]
            },
];
